import dayjs from "dayjs";
import PdfHeader from "../../../../components/pafHeader";

const AllCompliantReport = ({ data, date, reportType = "LAWYERS", getPdfTitle, complaintStatus, selectedMonth, selectedMonthString }) => {
	return <div className="print-page">
		<div className="report-container" style={{ padding: 0, margin: 0 }}>
			<PdfHeader pdfName={getPdfTitle(reportType)} />
			<div className="total-details flexible">
                {
                    (date?.fromDate && date?.toDate) &&<>
					<div>
						<h4 className="information-title">Date</h4>
						<p style={{ margin: 0, padding: "10px 0px" }}>{date?.fromDate && date?.toDate ? `${dayjs(date?.fromDate).format("DD-MM-YYYY")} to ${dayjs(date?.toDate).format("DD-MM-YYYY")}` : "-"}</p>
					</div>
					</>
                }
                {
                    selectedMonth && <>
                        <div>
                            <h4 className="information-title">Month</h4>
                            <p style={{ margin: 0, padding: "10px 0px" }}>{dayjs(selectedMonth).format("MMMM YYYY")}</p>
                        </div>
                    </>
                }
				<div>
					<h3 className="information-title">Complaints</h3>
					<h2 className="information-detail">{data?.length}</h2>
				</div>
			</div>
			<table className="report-table">
				<thead>
					<tr>
						<th colSpan={1}>SNo</th>
						<th colSpan={3}>Date</th>
						<th colSpan={3}>Cons. ID</th>
						<th colSpan={3}>Raised By & ID</th>
						<th colSpan={3}>Against By & ID</th>
						<th colSpan={6}>Complaint Description</th>
						{complaintStatus === "COMPLETED" && <th colSpan={4}>Action Taken</th>}
						{complaintStatus === "COMPLETED" && <th colSpan={4}>Action Type</th>}
						{complaintStatus === "COMPLETED" && <th colSpan={4}>Warned By</th>}
						<th colSpan={4}>Record</th>
						<th colSpan={4}>Status</th>
					</tr>
				</thead>
			<tbody>
					{data?.map((detail, index) => (
						<tr key={detail?.id}>
							<td colSpan={1}>{index + 1}</td>
							<td colSpan={3}>{detail?.complaintDate ? dayjs(detail?.complaintDate).format("DD-MM-YYYY") : "Nil"}</td>
							<td colSpan={3}>{detail?.consultationNo || "Nil"}</td>
							<td colSpan={3}>
								{detail?.raisedByName && detail?.raisedByNo ? (
									<>
										<span style={{ fontWeight: '600'}}>{detail?.raisedByName}</span>
										<br />
										<small>{detail?.raisedByNo}</small>
									</>
								) : (
									detail?.raisedByName || "Nil"
								)}
							</td>
							<td colSpan={3}>
								{detail?.againstByName && detail?.againstByNo ? (
									<>
										<span style={{ fontWeight: '600'}}>{detail?.againstByName}</span>
										<br />
										<small>{detail?.againstByNo}</small>
									</>
								) : (
									detail?.againstByName || "Nil"
								)}
							</td>
					<td colSpan={6}>{detail?.complaintDescription || "Nil"}</td>
				{complaintStatus === "COMPLETED" && <td colSpan={4}>{detail?.actionItemRaisedBy || "Nil"}</td>}
				{complaintStatus === "COMPLETED" && <td colSpan={4}>{detail?.complaintActionType || "Nil"}</td>}
				{complaintStatus === "COMPLETED" && <td colSpan={4}>{detail?.warnedByName || "Nil"}</td>}
							<td colSpan={4}>
								{
									detail?.record === "Recorded" ? <div className="success-status">
										<p className="custom-header">Recorded</p>
									</div> : <div className="danger-status">
										<p className="custom-header">Not Recorded</p>
									</div>
								}
							</td>
							<td colSpan={4}>
								{
									detail?.complaintStatus === "COMPLETED" ? <div className="success-status">
										<p className="custom-header">Completed</p>
									</div> : detail?.complaintStatus === "PENDING" ? <div className="pending-status">
										<p className="custom-header">Pending</p>
									</div> : <div style={{textAlign:"center"}}>Nil</div>
								}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	</div>;
};

export default AllCompliantReport;
